module.exports = __webpack_public_path__ + "button-cart.svg?bcd553ec59a9c76646ce7f83599850b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-cart.svg
// module id = 564
// module chunks = 0